import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { Auth } from 'aws-amplify';
import Stripe5 from './Stripe5';
import GetEventSeatsInfo from './GetEventSeatsInfo';
import ChangeSeatStatus from './ChangeSeatStatus'
import PurchasePreview from './PurchasePreview'


function EventSeatChart() {

    const [event, setEvent] = useState({eventName: '',dateTime: ''});
    const [rows, setRows] = useState([]);
    const [reserved, setReserved] = useState([]);
    const [seats, setSeats] = useState({});
    const [seatDetails, setSeatDetails] = useState({});
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [sessionUserName, setSessionUserName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [reload, setReload] = useState(0);
    const [SKRoot, setSKRoot] = useState('2021-08-08-20-30');
    const [PK, setPK] = useState('123');
    const [loadEvent, setLoadEvent] = useState('event-details-' + SKRoot);


    function chgClassName(seat, status, reserved){
        if(reserved.indexOf(seat) > -1){
            return 'reserved';
        }else if (seat == 'ns') {
            return 'ns';
        }else if( seat in seats){
            return seats[seat];
        } else {
            return status;
        }
    }

    function onClickData(seat, reserved, setReserved) {
        if((seats[seat] !== 'sold') && (seats[seat] !== 'ns' )&& (seats[seat] !== 'reserved2')){
            if(reserved.indexOf(seat) > -1 ) {
                setReserved([])
                setSeatDetails({})
                console.log("SPOT5:", reserved)
            }else{
                setReserved([...reserved, seat]);
                setSeatDetails({...seatDetails, [seat]: {seatID: seat, seatPrice: event.eventSeatPriceAdult, seatPriceCode: "Adult"}})
                console.log("SPOT6:", reserved)
            }
        }
        console.log(seat)
        console.log("RESERVED", reserved)
    }

    function Refresh(){
        if(reload == 0){
            setReload(1);
        }else{
            setReload(0)
        }
    }

    async function ReserveSeatsInDB(seatStatus, firstName, lastName){
        reserved.map( rseat => {
            console.log("RSEAT", rseat)
            console.log("FIRSTNAME", firstName)
            let SKey = 'event-' + SKRoot + '-seat-' + rseat
            ChangeSeatStatus(rseat, seatStatus, PK, SKey, firstName, lastName, sessionUserName);
        })
        setReserved([])
    }

    async function EventSeatChart() {
        setRows([])
        console.log("SKRoot",SKRoot)
        console.log("loadEvent",loadEvent)
        await Auth.currentSession()
            .then(data => console.log("AUTHDATA",data.accessToken.payload.username))
            .catch(err => console.log("AUTHERRORDATA",err));
        const testuser = await Auth.currentAuthenticatedUser()
        console.log("TESTUSER",testuser.username)
        setSessionUserName(testuser.username)   
        let myInit = {
            body:{
                "Action": "getEventSeatChart",
                "SK": loadEvent,
                "PK": PK
            }
        }
        const apiData = await API.post ('ticket57api', '/events', myInit)
        let response = await GetEventSeatsInfo(PK, 'event-' + SKRoot + '-seat')
        let seatInfo = {};
        response.map( seat => {
            console.log("SEATS11",seat)
            seatInfo[seat.seatID] = seat.seatStatus
            console.log("SEATINFO",seatInfo)
        })
        setSeats(seatInfo)
        console.log("APIDATA",apiData)
        console.log("SEATS", seats)
        setEvent(apiData[0]);
        setRows(apiData[0].rows);
    }

    useEffect(() => {
        EventSeatChart()
    },[reload, loadEvent])
    
    let counter = 0
    return (
    <div className="App">
        <header className="App-header">
        <div className="seatTable">   
        <p><button onClick={e => setLoadEvent('event-details-' + SKRoot)}>Get Event:</button><input type="text" value={SKRoot} onChange={event => setSKRoot(event.target.value)}/></p>
        <h1>{event.eventName}</h1>
        <h1>{event.dateTime}</h1>   
        <div className="seatTable">
        <table className="grid">    
        <tbody>             
              {rows.map( row => {
                  counter += 1
                  return <tr id={row.rowId + counter.toString()} key={row.rowId}>
                  {row.rowMap.map( seat => { 
                  counter += 1    
                  //return <td id={seat}className="available"> {seat}
                  return <td id={seat + counter.toString()} className={chgClassName(seat, "available", reserved)} key={seat} onClick = {e => {onClickData(seat, reserved, setReserved)}}>
                      {seat}
                  </td>
                  })}              
                  </tr>
                })}              
          </tbody>
        </table>
        <div className="stage">STAGE</div>       
        </div>
        <div className="seatinfo">
            <p>Session UserName: {sessionUserName}</p>
        <table> 
        <tbody>     
        <tr><td>Customer First Name:</td><td><input className='purchasePreviewInput' type="text" value={firstName} onChange={event => setFirstName(event.target.value)}/></td></tr>
        <tr><td>Customer Last Name:</td><td><input className='purchasePreviewInput' type="text" value={lastName} onChange={event => setLastName(event.target.value)}/></td></tr>
        <tr><td>Customer Email:</td><td><input className='purchasePreviewInput' type="text" value={emailAddress} onChange={event => setEmailAddress(event.target.value)}/></td></tr>
        </tbody>
        </table>
        <PurchasePreview reserved={reserved} seatDetails={seatDetails} setSeatDetails={setSeatDetails} event={event} firstName={firstName} lastName={lastName} emailAddress={emailAddress}/>
        <p><button onClick={e => {ReserveSeatsInDB("reserved2", firstName, lastName ); Refresh()}}>Reserve Seats</button></p>
        <p><button onClick={e => {ReserveSeatsInDB("sold", firstName, lastName ); Stripe5(event.eventName + "-" + event.dateTime, emailAddress, reserved, '1234567', seatDetails, PK, SKRoot)}}>Purchase Seats</button></p> 
        </div>
        </div>
        </header>
    </div>
    );
}

export default EventSeatChart